/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {dlsColor} from '@ion/dls/src/theme/theme';

const rowHighlightSelector = [
  '& .ag-row-hover.ag-row-hover:not(.row-has-error)',
  '& .ag-row-hover:not(.row-has-error)',
  '& .ag-row-selected.ag-row-selected:not(.row-has-error)',
  '& .ag-row-selected:not(.row-has-error)',
  '& .ag-row-focus.ag-row-focus:not(.row-has-error)',
  '& .ag-row-focus:not(.row-has-error)'
].join(', ');

export const getEditableRowsGridOverrides = () => {
  const encodedGrey3 = `${dlsColor('grey3')}`.replace('#', '%23');
  const menuAltIconSvg = [
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">',
    `<path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z" fill="${encodedGrey3}"/>`,
    '</svg>'
  ].join('');

  return {
    width                              : '100%',
    flex                               : 1,
    minHeight                          : 0,
    '--ag-icon-image-opacity-menu-alt' : 1,
    '--ag-icon-image-menu-alt'         : `url("data:image/svg+xml,${menuAltIconSvg}")`,
    [rowHighlightSelector]             : {
      backgroundColor : `${dlsColor('paleBlue')} !important`,
      backgroundImage : 'none !important',
      '&::before'     : {
        backgroundColor : `${dlsColor('paleBlue')} !important`,
        backgroundImage : 'none !important'
      }
    },
    '& .ag-cell.invalid-cell' : {
      color : `${dlsColor('caRed')} !important`
    },
    '& .ag-row.row-has-error, & .ag-row.row-has-error.ag-row-selected, & .ag-row.row-has-error.ag-row-hover, & .ag-row.row-has-error.ag-row-focus, & .ag-row.row-has-error::before' : {
      backgroundColor : `${dlsColor('caRed')}10 !important`,
      backgroundImage : 'none !important'
    },
    '& .ag-cell.ag-cell-inline-editing' : {
      border       : '0 !important',
      borderBottom : `2px solid ${dlsColor('caBlue')} !important`,
      boxShadow    : 'none !important',
      background   : 'transparent !important',
      padding      : '0 !important'
    },
    '& .ag-cell.ag-cell-inline-editing .ag-cell-edit-wrapper' : {
      height       : '100%',
      display      : 'flex',
      alignItems   : 'center',
      padding      : '0 14px',
      border       : '0 !important',
      boxShadow    : 'none !important',
      borderRadius : '0 !important',
      background   : 'transparent !important',
      borderBottom : `2px solid ${dlsColor('caBlue')} !important`
    },
    '& .ag-cell.ag-cell-inline-editing .ag-wrapper.ag-picker-field-wrapper' : {
      height       : '100% !important',
      border       : '0 !important',
      boxShadow    : 'none !important',
      borderRadius : '0 !important',
      background   : 'transparent !important'
    },
    '& .ag-cell.ag-cell-inline-editing .ag-wrapper.ag-picker-field-wrapper.ag-rich-select-value.ag-picker-expanded, & .ag-popup-editor.ag-popup-child .ag-wrapper.ag-picker-field-wrapper.ag-rich-select-value.ag-picker-expanded' : {
      backgroundColor : `${dlsColor('paleBlue')} !important`,
      borderBottom    : `2px solid ${dlsColor('caBlue')} !important`
    },
    '& .ag-cell.ag-cell-inline-editing .ag-picker-field-display' : {
      paddingLeft : '14px'
    },
    '& .ag-cell.ag-cell-inline-editing .ag-picker-field-icon:not(.ag-rich-select-deselect-button), & .ag-picker-field.ag-rich-select .ag-picker-field-icon:not(.ag-rich-select-deselect-button)' : {
      display    : 'flex !important',
      visibility : 'visible !important',
      opacity    : '1 !important'
    },
    '& .ag-picker-field-icon.ag-hidden:not(.ag-rich-select-deselect-button)' : {
      display : 'flex !important'
    },
    '& .ag-rich-select-deselect-button, & .ag-rich-select-deselect-button.ag-hidden' : {
      display : 'none !important'
    },
    '& .ag-cell.ag-cell-inline-editing .ag-input-field-input, & .ag-cell.ag-cell-inline-editing input' : {
      border     : '0 !important',
      outline    : '0 !important',
      boxShadow  : 'none !important',
      background : 'transparent !important',
      padding    : '0 !important'
    },
    '& .ag-cell.ag-cell-inline-editing input.can-request-payload-editor-input' : {
      padding   : '0 14px !important',
      height    : '100%',
      boxSizing : 'border-box'
    },
    '& .ag-cell.ag-cell-inline-editing input::selection' : {
      background : 'transparent'
    },
    '& .ag-popup-editor.ag-popup-child .ag-rich-select-list' : {
      borderRadius : '0 !important',
      boxShadow    : 'none !important'
    },
    '& .ag-popup-editor.ag-popup-child .ag-rich-select-row, & .ag-popup-editor.ag-popup-child .ag-rich-select-virtual-list-item' : {
      minHeight   : '42px !important',
      height      : '42px !important',
      display     : 'flex',
      alignItems  : 'center',
      boxSizing   : 'border-box',
      padding     : '0 14px !important',
      lineHeight  : '20px !important',
      border      : '0 !important',
      borderColor : 'transparent !important'
    },
    '& .ag-popup-editor.ag-popup-child .ag-rich-select-row.ag-rich-select-row-selected, & .ag-popup-editor.ag-popup-child .ag-rich-select-row.ag-rich-select-row-highlighted, & .ag-popup-editor.ag-popup-child .ag-rich-select-row:hover' : {
      backgroundColor : `${dlsColor('paleBlue')} !important`
    },
    '& .ag-header-cell[col-id="__actions"] .ag-header-cell-menu-button' : {
      display : 'none !important'
    },
    '& .ag-cell[col-id="__actions"]' : {
      outline   : 'none !important',
      boxShadow : 'none !important'
    },
    '& .ag-cell[col-id="__actions"].ag-cell-focus, & .ag-cell[col-id="__actions"].ag-cell-range-selected, & .ag-cell[col-id="__actions"].ag-cell-range-single-cell, & .ag-cell[col-id="__actions"].ag-cell-range-left, & .ag-cell[col-id="__actions"].ag-cell-range-right, & .ag-cell[col-id="__actions"].ag-cell-range-top, & .ag-cell[col-id="__actions"].ag-cell-range-bottom' : {
      outline    : 'none !important',
      boxShadow  : 'none !important',
      border     : '0 !important',
      borderLeft : '1px solid transparent !important'
    }
  };
};
